import React from 'react';
import styles from './TermsAndCondition.module.css';
import { FormattedMessage, useIntl } from 'react-intl';

const TermsAndCondition = ({ isCheckedTerms, isChecked }) => {
  const intl = useIntl();
  return (
    <div>
      <div className={styles['terms']}>
        <div className={styles['name']}>
          <FormattedMessage id="grave.new.info.title" />
        </div>
        <div className={styles['text']}>
          <FormattedMessage id="grave.new.info.line1" />
        </div>
        <div className={styles['text']}>
          <FormattedMessage id="grave.new.info.line2" />
        </div>
        <div className={styles['text']}>
          <FormattedMessage id="grave.new.info.line3" />
        </div>
      </div>
      <div className={styles['accept-container']}>
        <input
          type="checkbox"
          onChange={() => isCheckedTerms(!isChecked)}
          checked={isChecked}
          aria-label={intl.formatMessage({ id: 'grave.new.accept_label' })}
        />
        <div className={styles['label']}>
          <FormattedMessage id="grave.new.accept_label" />
        </div>
      </div>
    </div>
  );
};

export default TermsAndCondition;
